import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useEffect, useState } from "react";
import email from "../assets/img/email.svg";
import github from "../assets/img/github.svg";
import linkedin from "../assets/img/linkedin.svg";
import { HashLink } from "react-router-hash-link";
import { HashRouter as Router } from "react-router-dom";
import ResumeModal from "./ResumeModal";
import AboutModal from "./AboutModal";

const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  const handleAboutClose = () => setShowAboutModal(false);
  const handleAboutShow = () => setShowAboutModal(true);

  return (
    <Router>
      <Navbar expand="lg" className={scrolled ? "scrolled" : ""} style={{ zIndex: 1000 }}>
        <Container>
          <Navbar.Brand href="#home">
            {/* <img src={""} alt="Logo" /> */}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <HashLink
                smooth
                to="#home"
                className={
                  activeLink === "home"
                    ? "nav-link navbar-link active"
                    : "nav-link navbar-link"
                }
                onClick={() => onUpdateActiveLink("home")}
              >
                Home
              </HashLink>
              <Nav.Link
                className={
                  activeLink === "about"
                    ? "nav-link navbar-link active"
                    : "nav-link navbar-link"
                }
                onClick={handleAboutShow}
              >
                About
              </Nav.Link>
              <HashLink
                smooth
                to="#skills"
                className={
                  activeLink === "skills"
                    ? "nav-link navbar-link active"
                    : "nav-link navbar-link"
                }
                onClick={() => onUpdateActiveLink("skills")}
              >
                Skills
              </HashLink>
              {/* <div id="projects"> */}
              <HashLink
                smooth
                to="#projects"
                className={
                  activeLink === "projects"
                    ? "nav-link navbar-link active"
                    : "nav-link navbar-link"
                }
                onClick={() => onUpdateActiveLink("projects")}
              >
                Projects
              </HashLink>

              {/* </div> */}
              <ResumeModal
                className={
                  activeLink === "experience"
                    ? "nav-link navbar-link active"
                    : "nav-link navbar-link"
                }
                onClick={() => onUpdateActiveLink("experience")}
              />
              <Nav.Link
                href="https://shireneboyd.hashnode.dev/"
                alt="Shirene's blog dashboard"
                target="_blank"
                rel="noopener noreferrer"
                className={
                  activeLink === "blog" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("blog")}
              >
                Blog
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="mailto:shirenekboyd@gmail.com">
                  <img src={email} alt="email link"></img>
                </a>
                <a
                  href="https://github.com/shirenekboyd"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={github} alt="github link"></img>
                </a>
                <a
                  href="https://www.linkedin.com/in/shirene-boyd"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedin} alt="linkedin link"></img>
                </a>
              </div>
              <HashLink to="#connect">
                <button className="vvd" onClick={() => console.log("connect")}>
                  <span>Let's Connect</span>
                </button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <AboutModal show={showAboutModal} handleClose={handleAboutClose} />
    </Router>
  );
};

export default NavBar;
